<i18n src="@/i18n/components/search/filter.json"></i18n>
<template>
  <FilterBaseSelectBox
    :value="businessEventDefinitionId"
    :options="options"
    :prefix="$t('businessEventPrefix')"
    class="filter-business-event-form"
    @input="onInput"
  />
</template>

<script lang="ts">
import { Component, Prop, Model, Vue } from "vue-property-decorator";
import { BusinessEventDefinition } from "@/models/client-settings/BusinessEventDefinition";

import SelectOption from "@/components/form/SelectOption";
import FilterBaseSelectBox from "@/components/filter/form/FilterBaseSelectBox.vue";

@Component({
  components: {
    FilterBaseSelectBox
  }
})
export default class FilterBusinessEventField extends Vue {
  @Model("input", { type: Number, required: true })
  businessEventDefinitionId!: number;

  @Prop({ type: Array, required: true })
  businessEventDefinitions!: BusinessEventDefinition[];

  get options(): SelectOption[] {
    return this.businessEventDefinitions.map(def => {
      return { label: def.name, value: def.id, disabled: false };
    });
  }

  onInput(businessEventDefinitionId: number) {
    this.$emit("input", businessEventDefinitionId);
  }
}
</script>
